import {
  useEditBrandBilling,
  useLinkBrandToBilling,
} from "@entities/billingBrand/lib/hooks";
import { useGetBrandBillingById } from "@entities/billingBrand/lib/hooks/useGetBrandBillingById";
import { ToastService } from "@shared/lib/services";
import { IBrandBilling } from "@shared/lib/types/brandBilling";
import { CircularProgress } from "@shared/ui";
import { Modal, Row } from "antd";
import { useEffect, useState } from "react";
import { DetailCard } from "./DetailCard";
import { BrandBillingUpdateForm } from "@entities/billingBrand/ui/BrandBillingUpdateForm";
import { LinkedBrands } from "./LinkedBrands";
import { AddBillingBrand } from "./AddBillingBrand";

interface ManageBillingBrandProps {
  billingId: string;
}

export function ManageBillingBrand({ billingId }: ManageBillingBrandProps) {
  const { brandBilling, isFetching } = useGetBrandBillingById(billingId);
  const { edit, isEdited, isEditing } = useEditBrandBilling();
  const [isModalVisible, setModalVisible] = useState(false);
  const [isLinkModalVisible, setLinkModalVisible] = useState(false);

  const handleSubmit = (billingData: Partial<IBrandBilling>) => {
    edit({ brandBilling: billingData, billingId });
  };

  const { isLinked, error, isLinking, link } = useLinkBrandToBilling();

  useEffect(() => {
    if (isLinked) {
      ToastService.success("Brand Linked");
      setLinkModalVisible(false);
    }
  }, [isLinked]);

  useEffect(() => {
    if (isEdited) {
      ToastService.success("Billing Updated");
      setModalVisible(false);
    }
  }, [isEdited]);

  if (isFetching) {
    return (
      <Row justify={"center"}>
        <CircularProgress />
      </Row>
    );
  }
  if (!brandBilling) return <></>;

  return (
    <div>
      <DetailCard
        billing={brandBilling}
        onEditClick={() => setModalVisible(true)}
      />

      <LinkedBrands
        linkedBrands={brandBilling.linkToBrands || []}
        billingId={billingId}
        onAddClick={() => setLinkModalVisible(true)}
      />

      <Modal
        title={"Update Billing"}
        open={isModalVisible}
        onCancel={() => {
          setModalVisible(false);
        }}
        footer={null}
        destroyOnClose
      >
        <BrandBillingUpdateForm
          onSubmit={handleSubmit}
          isSubmitting={isEditing}
          initialValues={brandBilling}
        />
      </Modal>

      <Modal
        title={"Link Brand"}
        open={isLinkModalVisible}
        onCancel={() => {
          setLinkModalVisible(false);
        }}
        footer={null}
        destroyOnClose
      >
        <AddBillingBrand
          alreadyAddedUsers={
            brandBilling.linkToBrands?.map((item) => item._id) || []
          }
          onSubmit={(val) => {
            link({ brandIds: val, billingId });
          }}
          isSubmitting={isLinking}
          isLinked={isLinked}
        />
        {/* TODO: Add LinkBrandForm component here */}
      </Modal>
    </div>
  );
}
